import { Component, Input, OnInit } from '@angular/core';
import { AppComponent } from 'app/app.component';
import { CommunicationService } from 'app/_services/communication.service';
import { ISettings } from 'app/_models/ISettings';
import { IconDefinition, faDatabase, faXmark, faTrash } from '@fortawesome/free-solid-svg-icons';
import { UtilService } from 'app/_services/util.service';

@Component({
  selector: 'storage-management-component',
  templateUrl: './storage-management.component.html',
  styleUrls: ['./storage-management.component.css']
})
export class StorageManagementComponent implements OnInit {
  //#region Fields & Icons
  @Input() settings: ISettings;
  i: number = 0;
  storageItems: { viewName: string, storageKey: string, filters: string, sort: string }[] = [];
  faDatabase: IconDefinition = faDatabase;
  faXmark: IconDefinition = faXmark;
  faTrash: IconDefinition = faTrash;
  //#endregion

  constructor(
    public app: AppComponent,
    private communicationService: CommunicationService,
    private utilService: UtilService
  ) { }

  async ngOnInit(): Promise<void> {    
    for (let key in localStorage) {
      if (!key.includes('filters') && !key.includes('sort')) continue;      
      let filterString = '';
      let sortString = '';
      let nodeId = key.split('_')[2];
      
      if (isNaN(Number(nodeId))) {
        nodeId = key.split('_')[3];
        if (!nodeId) continue;
      } 
      
      let viewName = await this.getViewName(nodeId);      
      if (key == `qx_sort_${nodeId}`) {        
        sortString = JSON.parse(localStorage.getItem(key)).sortString; 
        let storageItem = this.storageItems.find(item => item.viewName == viewName);
        if (storageItem) {
          storageItem.sort = sortString;
          storageItem.storageKey = `${storageItem.storageKey}|${key}`
        } 
        else this.storageItems.push({ viewName: viewName, storageKey: key, filters: filterString, sort: sortString });       
      } else if (key.includes(`qx_sort_${nodeId}_`)) {
        sortString = JSON.parse(localStorage.getItem(key)).sortString;
        let detailViewName = key.split('_')[3];
        let storageItem = this.storageItems.find(item => item.storageKey.includes(detailViewName));
        if (storageItem) {
          storageItem.sort = sortString;
          storageItem.storageKey = `${storageItem.storageKey}|${key}`
        } 
        else this.storageItems.push({ viewName: `${viewName} > ${detailViewName}`, storageKey: key, filters: filterString, sort: sortString });
      }

      if (key == `qx_filters_${nodeId}`) {        
        filterString = JSON.parse(localStorage.getItem(key)).filterString;  
        let storageItem = this.storageItems.find(item => item.viewName == viewName); 
        if (storageItem) {
          storageItem.filters = filterString;
          storageItem.storageKey = `${storageItem.storageKey}|${key}`;
        } 
        else this.storageItems.push({ viewName: viewName, storageKey: key, filters: filterString, sort: sortString });      
      } else if (key.includes(`qx_filters_${nodeId}_`)) {
        filterString = JSON.parse(localStorage.getItem(key)).filterString;  
        let detailViewName = key.split('_')[3];
        let storageItem = this.storageItems.find(item => item.storageKey.includes(detailViewName));
        if (storageItem) {
          storageItem.filters = filterString;
          storageItem.storageKey = `${storageItem.storageKey}|${key}`
        } 
        else this.storageItems.push({ viewName: `${viewName} > ${detailViewName}`, storageKey: key, filters: filterString, sort: sortString });
      } 
      
      if (key == `qx_filters_advanced_${nodeId}`) {
        nodeId = key.split('_')[3];
        filterString = JSON.parse(localStorage.getItem(key)).userString;
        let storageItem = this.storageItems.find(item => item.viewName == viewName); 
        if (storageItem) {
          storageItem.filters = filterString;
          storageItem.storageKey = `${storageItem.storageKey}|${key}`
        } 
        else this.storageItems.push({viewName: viewName, storageKey: key, filters: filterString, sort: sortString});
      } else if (key.includes(`qx_filters_advanced_${nodeId}_`)) {
        nodeId = key.split('_')[3];
        filterString = JSON.parse(localStorage.getItem(key)).userString;
        let detailViewName = key.split('_')[4];
        let storageItem = this.storageItems.find(item => item.storageKey.includes(detailViewName));
        if (storageItem) {
          storageItem.filters = filterString;
          storageItem.storageKey = `${storageItem.storageKey}|${key}`
        } 
        else this.storageItems.push({ viewName: `${viewName} > ${detailViewName}`, storageKey: key, filters: filterString, sort: sortString });
      }
    }        
  }

  async getViewName(nodeId: string): Promise<string> {
    return new Promise<string>((resolve) => {
      let formData = this.app.buildForm(['nodeId'], [nodeId]);
      this.utilService.getViewName(formData).subscribe({
        next: (data: { viewName: string }) => { resolve(data.viewName); },
        error: (errorLog) => { console.log(errorLog); }
      });
    });
  }  

  removeFilterItem(item: any): void {
    let keys = item.storageKey.split('|');
    if (keys.length == 1) localStorage.removeItem(item.storageKey);
    else if (keys[0].includes('filters')) {
      localStorage.removeItem(keys[0]);
      item.storageKey = item.storageKey.replace(keys[0], '');
    } else if (keys[1].includes('filters')) {
      localStorage.removeItem(keys[1]);
      item.storageKey = item.storageKey.replace(keys[1], '');
    }
    
    item.storageKey = item.storageKey.replace('|', '');
    item.filters = '';
  }

  removeSortItem(item: any): void {
    let keys = item.storageKey.split('|');
    if (keys.length == 1) localStorage.removeItem(item.storageKey);
    else if (keys[0].includes('sort')) {
      localStorage.removeItem(keys[0]);
      item.storageKey = item.storageKey.replace(keys[0], '');
    } else if (keys[1].includes('sort')) {
      localStorage.removeItem(keys[1]);
      item.storageKey = item.storageKey.replace(keys[1], '');
    }

    item.storageKey = item.storageKey.replace('|', '');
    item.sort = '';
  }

  deleteAll(): void {
    this.storageItems.forEach(item => {
      let keys = item.storageKey.split('|');
      if (keys.length == 1) localStorage.removeItem(item.storageKey);
      else {
        localStorage.removeItem(keys[0]);
        localStorage.removeItem(keys[1]);
      }
      item.sort = '';
      item.filters = '';
    })
  }

  close(): void {
    this.communicationService.closeStorageManagementDialog();
  }
}
